/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function EmailTemplatesEditViewController(
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    $route: JS5Object,
    $routeParams: JS5Object,
    $timeout: JS5Function,
    BreadcrumbService: JS5Object,
    EmailTemplatesService: JS5Object,
    ModalService: JS5Object,
    PermissionsService: JS5Object,
    SidebarService: JS5Object,
) {
    this.editData = {};
    const getData = () => {
        this.loadingIndicator.show = true;
        EmailTemplatesService.getEmailTemplate($routeParams.id).then((emailTemplate: JS5Object) => {
            EmailTemplatesService.originalEditData = _.cloneDeep(emailTemplate);
            this.editData = emailTemplate;
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const saveHandler = () => {
        this.loadingIndicator.show = true;
        if ($routeParams.id === '-1') {
            saveNewEmailTemplate();
        }
        else {
            updateEmailTemplate();
        }
    };

    const updateEmailTemplate = () => {
        EmailTemplatesService.updateEmailTemplate(this.editData).then((emailTemplate: JS5Object) => {
            EmailTemplatesService.originalEditData = _.cloneDeep(emailTemplate);
            this.editData = emailTemplate;
            this.editorForm.$setPristine();
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };
    const saveNewEmailTemplate = () => {
        EmailTemplatesService.createEmailTemplate(this.editData).then((emailTemplate: JS5Object) => {
            $route.updateParams({id: emailTemplate.id});
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => !_.get(this.editorForm, '$pristine') && _.size(_.get(this.editData, 'name')),
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: () => !_.get(this.editorForm, '$pristine'),
            onClick: () => {
                this.editData = _.cloneDeep(EmailTemplatesService.originalEditData);
                this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: () => !_.get(this.editorForm, '$dirty'),
            onClick: () => $location.url(`/system/templates/search`).search({tab: 'EmailTemplates'})
        }
    ];


    this.$onInit = () => {
        SidebarService.editService = EmailTemplatesService;
        this.isAdmin = PermissionsService.isAdmin();
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        if (this.isAdmin) {
            if ($routeParams.id !== '-1') {
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                    BreadcrumbService.addBreadcrumb({
                        name: 'Edit Email Template',
                        location: '/system/templates/search',
                        params: {tab: 'EmailTemplates'}
                    });
                }
                getData();
            } else {
                BreadcrumbService.addBreadcrumb({
                    name: 'Create Email Template',
                    location: '/system/templates/search',
                    params: {tab: 'EmailTemplates'}
                });
            }
        } else {
            $location.url('/login');
        }
    };

    this.$onDestroy = () => {
        EmailTemplatesService.originalEditData = null;
        EmailTemplatesService.viewData = null;
    };

    this.$postLink = () => {
        $timeout(() => {
            EmailTemplatesService.editorForm = this.editorForm;
            BreadcrumbService.editService = EmailTemplatesService;
        });
    };
}


angular.module('prism-ui.emailTemplates').component('emailTemplatesEditView', {
    templateUrl: 'system/emailTemplate/editor/email-template-edit-template.html',
    controller: EmailTemplatesEditViewController,
    bindings: {
    }
});
